/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './event-image.reducer';

export const EventImageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const eventImageEntity = useAppSelector(state => state.eventImage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="eventImageDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.eventImage.detail.title">EventImage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.eventImage.id">Id</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.id}</dd>
          <dt>
            <span id="eventId">
              <Translate contentKey="tinyMedicRestApp.eventImage.eventId">Event Id</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.eventId}</dd>
          <dt>
            <span id="eventType">
              <Translate contentKey="tinyMedicRestApp.eventImage.eventType">Event Type</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.eventType}</dd>
          <dt>
            <span id="mediaName">
              <Translate contentKey="tinyMedicRestApp.eventImage.mediaName">Media Name</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.mediaName}</dd>
          <dt>
            <span id="originalFilePath">
              <Translate contentKey="tinyMedicRestApp.eventImage.originalFilePath">Original File Path</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.originalFilePath}</dd>
          <dt>
            <span id="originalFileName">
              <Translate contentKey="tinyMedicRestApp.eventImage.originalFileName">Original File Name</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.originalFileName}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="tinyMedicRestApp.eventImage.message">Message</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.message}</dd>
          <dt>
            <span id="mimeType">
              <Translate contentKey="tinyMedicRestApp.eventImage.mimeType">Mime Type</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.mimeType}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.eventImage.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.sortOrder}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.eventImage.status">Status</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.status}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.eventImage.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.addedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.eventImage.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.eventImage.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.modifiedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.eventImage.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.modifiedByType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.eventImage.active">Active</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.eventImage.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.eventImage.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.eventImage.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.eventImage.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{eventImageEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.eventImage.patient">Patient</Translate>
          </dt>
          <dd>{eventImageEntity.patient ? eventImageEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/event-image" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/event-image/${eventImageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EventImageDetail;
